import api from "@/lib/api";

const isMobile = () => window.matchMedia("(max-width: 767px)").matches || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

// Downloads the quotation PDF; on mobile, opens the native share sheet (WhatsApp, email, …) when supported.
export async function downloadQuotationPdf(q) {
  const r = await api.get(`/quotations/${q.id}/pdf`, { params: { download: true }, responseType: "blob" });
  const name = q.pdf_filename || "Quotation.pdf";
  const file = new File([r.data], name, { type: "application/pdf" });
  if (isMobile() && navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: name });
      return "shared";
    } catch (e) {
      if (e?.name === "AbortError") return "cancelled";
    }
  }
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return "downloaded";
}

export function todayLocal() {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}
